(() => {
  const bind = (scope) => {
    scope.querySelectorAll('[data-pace-page]').forEach((root) => {
      if (root.dataset.paceBound === 'true') return;
      root.dataset.paceBound = 'true';
      const search = root.querySelector('#docs-search');
      const group = root.querySelector('#docs-group');
      const rows = [...root.querySelectorAll('[data-document]')];
      if (!search || !group || !rows.length) return;
      const count = root.querySelector('#docs-count');
      const empty = root.querySelector('#docs-empty');
      const reset = root.querySelector('#docs-reset');
      const update = () => {
        const term = search.value.trim().toLocaleLowerCase();
        let visible = 0;
        rows.forEach((row) => {
          const matches = (!group.value || row.dataset.group === group.value) && (!term || row.textContent.toLocaleLowerCase().includes(term));
          row.hidden = !matches;
          if (matches) visible += 1;
        });
        if (count) count.textContent = `${visible} ${visible === 1 ? 'document' : 'documents'}`;
        if (empty) empty.hidden = visible > 0;
      };
      search.addEventListener('input', update);
      group.addEventListener('change', update);
      reset?.addEventListener('click', () => { search.value = ''; group.value = ''; update(); search.focus(); });
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind(document));
  else bind(document);
  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();
